import React, { Component } from 'react';
import "./Resume.css";

class CenterHeader extends Component {
    
    
    render() {
        return (
            <div className="col-md-4 center_header">
            <a href="http://www.charles-w-roberts.com/PdfLink/" rel="noopener noreferrer"  target="_blank">View as PDF</a>
                    </div>
        );
    }
} 

export default CenterHeader;

// <a href="https://www.charles-w-roberts.com/CharlesRoberts-Resume/" rel="noopener noreferrer"  target="_blank">View as PDF</a>



// WEBPACK FOOTER //
// ./src/components/Resume/CenterHeader.js